// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b40fa75e","239":"2eb0d31a","453":"c71fc253","455":"ee5f0b99"}[chunkId] + ".chunk.js";
};